/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Ring2All Team
 📄 File: hooks/useSavedFilters.ts
 🗓️ Created: 2025-12-02
 🧩 Description:
    Hook for loading saved CDR filters from the CDR Filters module
────────────────────────────────────────────────────────────────*/

import { useState, useEffect } from 'react';
import { fetchCdrFilters } from '../../cdrFilters/api/cdrFilterApi';
import { CdrFilter } from '../../cdrFilters/types';

export function useSavedFilters() {
  const [savedFilters, setSavedFilters] = useState<CdrFilter[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadFilters = async () => {
      try {
        setLoading(true);
        const response = await fetchCdrFilters({
          enabled: true,  // Solo filtros habilitados
          limit: 100,     // Cargar hasta 100 filtros
        });
        setSavedFilters(response.data);
      } catch (error) {
        console.error('Error loading saved filters:', error);
        setSavedFilters([]);
      } finally {
        setLoading(false);
      }
    };

    loadFilters();
  }, []);

  return {
    savedFilters,
    loading,
  };
}

